export class ViewConfig {
  loading = false;
  error: string | null = null;
  noData = false;

  constructor() {
    this.setDefault();
  }

  setNoData(value: boolean) {
    this.noData = value;
  }

  setLoading(value: boolean) {
    this.loading = value;
    this.error = null;
    this.setNoData(false);
  }

  setError(error: string | null) {
    this.setLoading(false);
    this.setNoData(false);
    this.error = error;
  }

  setDefault() {
    this.setLoading(false);
    this.setError(null);
    this.setNoData(false);
  }
}
